import { render } from "./AdFormatFilterItem.vue?vue&type=template&id=2bf3ccfb"
import script from "./AdFormatFilterItem.vue?vue&type=script&lang=js"
export * from "./AdFormatFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__